import React from 'react';
import { ChatInterface } from '../chat/ChatInterface';

/**
 * Admin-specific chat component wrapper
 * This allows for admin-specific customizations while using the shared ChatInterface
 */
export const AdminChat = ({ customerId }) => {
  return (
    <ChatInterface 
      customerId={customerId} 
      viewType="admin"
    />
  );
};

export default AdminChat;